import { apiRequest } from './client';
import type { WaitlistEntry } from '@outlinked/shared';

// Re-export the canonical type so consumers import from this file rather
// than reaching into @outlinked/shared directly (same pattern as runs.ts /
// unknown-ats.ts).
export type { WaitlistEntry };

export interface WaitlistListResponse {
  items: WaitlistEntry[];
  nextCursor: string | null;
}

export function listWaitlistEntries(
  opts: { cursor?: string; limit?: number } = {},
): Promise<WaitlistListResponse> {
  const params = new URLSearchParams();
  if (opts.cursor) params.set('cursor', opts.cursor);
  if (opts.limit) params.set('limit', String(opts.limit));
  return apiRequest<WaitlistListResponse>(`/waitlist?${params}`);
}

export function removeWaitlistEntry(email: string): Promise<{ ok: true; email: string }> {
  return apiRequest<{ ok: true; email: string }>(
    `/waitlist/${encodeURIComponent(email)}`,
    { method: 'DELETE' },
  );
}
